export default "__VITE_ASSET__a7066fe6__"